export default "/_next/static/images/search-modal-edfc9a07725890fc64719151b7e8e189.png";